var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticStyle:{"height":"calc(100vh - 94px)"}},[_c('tabs',{staticClass:"border-bottom",attrs:{"tabs":_vm.rutas}}),_c('div',{staticClass:"row mx-0"},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }